<template>
  <div class="about">
    <div class="top">
      <div class="top_title">最新文章</div>
      <div>
        <current-path>
           <template slot="fatherPath">
            首页
          </template>
          <template slot="sonPath">
            最新文章
          </template>
        </current-path>
      </div>
    </div>
    <div class="contentList">
      <news-list-item :data='item' v-for="item in list2" :key='item.id'></news-list-item>
    </div>
  </div>
</template>
<script>
import CurrentPath from '@/components/CurrentPath.vue'
import NewsListItem from '@/components/newsComponentsItem/NewsListItem'
export default {
  components: { CurrentPath, NewsListItem },
  data () {
    return {
      currentTab: 1, // 默认公司简介
      list2: [{
        id: 124,
        imgSrc: require('@/assets/news/u242.jpg'),
        title: '2019年2月份金融数据解读',
        date: '2018-08-06 15:47:49',
        seer: '18',
        content: '2月末，M2同比增长8%，社会融资规模存量同比增长10.1%，保持了平稳增长。前两个月，人民币新增贷款4.1万亿元，同比多增3748亿元；社融新增5.3万亿元,同比多增1.05万亿元……'
      },
      {
        id: 125,
        imgSrc: require('@/assets/news/u244.jpg'),
        date: '2018-08-08 15:47:49',
        seer: '19',
        title: '中国人民银行有关负责人就《关于加强非金融企业投资金融机构监管的指导意见》答记者问',
        content: '2018年4月27日，中国人民银行、中国银行保险监督管理委员会、中国证券监督管理委员会联合发布《关于加强非金融企业投资金融机构监管的指导意见》（以下简称《指导意见》）。针对社会各界关心的主要问题，中国人民银行有关负责人回答了记者提问……'
      },
      {
        id: 126,
        imgSrc: require('@/assets/news/u246.jpg'),
        date: '2018-08-08 15:47:49',
        seer: '16',
        title: '砥砺奋进 开拓创新 全面做好2019年金融市场和信贷政策工作',
        content: '2019年人民银行金融市场工作会议于2月25日至26日在北京召开。会议深入学习了党的十九大、十九届二中、三中和中央经济工作会议精神，以及2019年人民银行工作会议要求，总结了2018年人民银行系统金融市场和信贷政策工作，部署了2019年金融市场和信贷政策重点工作……'
      }
      ]
    }
  },
  methods: {
    changeTab (index) {
      this.currentTab = index
    }
  }
}
</script>
<style lang="stylus" scoped>
.about
  width 1200px
  margin 0 auto
  transform translateY(-40px)
.top
  width 900px
  padding 10px 20px
  background-color #ffffff
  margin 0 auto
  overflow hidden
  display flex
  justify-content space-between
  .top_title
    font-size 18px
    width 100px
    padding-bottom 10px
    border-bottom 1px solid #008000
.about_tab
  display flex
  justify-content flex-start
  margin-top 10px
  border-bottom 1px solid #CCCCCC
  padding-bottom: 20px;
  div
    padding 10px 20px
    font-size 18px
.activeTab
  background-color #E6AC00
  color #ffffff
  position relative
  &::after
    content ''
    display block
    position absolute
    width:0;
    height:0;
    border-width:7px 7px 0;
    border-style:solid;
    border-color:#E6AC00 transparent transparent;/*灰 透明 透明 */
    left 48px
    bottom -7px
.about_content
  margin-top 20px
  font-size 16px
  line-height 32px
  min-height 200px
  .idtent
    text-indent 32px
  .title
    font-size 25px
    color #D79900
  .fontColor
    color #D79900
  img
    margin: 0 auto;
    display: block;
    margin-top 20px

.contentList
  margin-top 20px
</style>
